import React from 'react';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import Badge from '@mui/material/Badge';
import Constants from 'style/constants';
import { FaultType } from 'shared/enums/fault-type';

import residentSettingsDeviceStatus from 'features/residents/resident-settings/components/columns/device-status-column/hooks/resident-settings-device-status';

type Props = {
  faults: FaultType[];
};

const DeviceStatusColumn = ({ faults }: Readonly<Props>): React.JSX.Element => (
  <>
    {faults?.length > 0 && (
      <div className="device-status-column-container">
        <Badge
          badgeContent={faults.length}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          color={residentSettingsDeviceStatus(faults)}
        >
          <WarningAmberRounded className="device-icon" sx={{ color: Constants.Colors.onSurface, width: 24, height: 24 }} />
        </Badge>
      </div>
    )}
  </>
);

export default DeviceStatusColumn;
